export default __webpack_public_path__ + "static/media/game_icons.cf0e0ec3.svg";